import React from 'react';

import { Button } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import notFound404Image from 'assets/images/illustrations/notFound.png';

import theme from 'constants/theme';

const StyledImage = styled.img`
  max-width: 25vw;
  min-width: 200px;
  position: relative;
`;

const StyledButton = styled(Button)`
  padding: 8px 40px;
  margin-bottom: 120px;
  text-transform: none;
`;

const Wrapper = styled.div`
  background: ${(props) => props.theme.palette.background.lightBlue40};
  height: 92vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NotFound404 = () => (
  <Wrapper>
    <StyledImage src={notFound404Image} />
    <StyledTypography weight={600} style={{ fontSize: '20px' }} color={theme.palette.text.heading}>
      OOPS... PAGE NOT FOUND
    </StyledTypography>

    <StyledTypography color={theme.palette.grey.dark} variant="caption" topGutter={2} bottomGutter={5}>
      We suggest you go to homepage
    </StyledTypography>

    <StyledButton onClick={() => window.open('/', '_self')} color="primary" variant="contained">
      <StyledTypography variant="body2" lineheight="24px">
        Go to Homepage
      </StyledTypography>
    </StyledButton>
  </Wrapper>
);

export default NotFound404;
